// @flow
import { SeaFlagActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    seaFlag: {},
    listaSeaFlags: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type SeaFlagAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { seaFlag?: {} | null, listaSeaFlags?: [] | null, loading?: boolean, +value ?: boolean };

const SeaFlag = (state: State = INIT_STATE, action: SeaFlagAction): any => {
    // console.log(action);
    switch (action.type) {
        case SeaFlagActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SeaFlagActionTypes.GET_SEA_FLAG: {
                    return {
                        ...state,
                        seaFlag: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeaFlagActionTypes.LIST_SEA_FLAGS: {
                    return {
                        ...state,
                        listaSeaFlags: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeaFlagActionTypes.ADD_SEA_FLAG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaFlagActionTypes.UPDATE_SEA_FLAG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaFlagActionTypes.DELETE_SEA_FLAG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeaFlagActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SeaFlagActionTypes.GET_SEA_FLAG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        seaFlag: {},
                        loading: false,
                    };
                }
                case SeaFlagActionTypes.LIST_SEA_FLAGS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaSeaFlags: [],
                        loading: false,
                    };
                }
                case SeaFlagActionTypes.ADD_SEA_FLAG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaFlagActionTypes.UPDATE_SEA_FLAG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaFlagActionTypes.DELETE_SEA_FLAG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeaFlagActionTypes.GET_SEA_FLAG:
            return { ...state, error: false, loading: true };
        case SeaFlagActionTypes.LIST_SEA_FLAGS:
            return { ...state, error: false, loading: true };
        case SeaFlagActionTypes.ADD_SEA_FLAG:
            return { ...state, error: false, loading: true };
        case SeaFlagActionTypes.UPDATE_SEA_FLAG:
            return { ...state, error: false, loading: true };
        case SeaFlagActionTypes.DELETE_SEA_FLAG:
            return { ...state, error: false, loading: true };
        case SeaFlagActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                seaFlag: {},
                listaSeaFlags: [],
                formSubmited: false
            };
        case SeaFlagActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default SeaFlag;
